// journal pages
export const JOURNAL_INTRO = "JOURNAL_INTRO";
export const JOURNAL_DESIGN_CHALLENGE = "JOURNAL_DESIGN_CHALLENGE";
export const JOURNAL_GRADEBOOK = "JOURNAL_GRADEBOOK";
export const JOURNAL_LOGS = "JOURNAL_LOGS";
export const JOURNAL_REFLECTION = "JOURNAL_REFLECTION";

export const JOURNAL_VALID_PAGES = [
  JOURNAL_INTRO,
  JOURNAL_DESIGN_CHALLENGE,
  JOURNAL_GRADEBOOK,
  JOURNAL_LOGS,
  JOURNAL_REFLECTION
];

// journal action types
export const JOURNAL_SELECT_PAGE = "JOURNAL_SELECT_PAGE";
export const JOURNAL_LOAD = "JOURNAL_LOAD";
export const JOURNAL_SAVE = "JOURNAL_SAVE";
export const JOURNAL_SAVE_SUCCESS = "JOURNAL_SAVE_SUCCESS";
export const JOURNAL_SAVE_FAILURE = "JOURNAL_SAVE_FAILURE";
export const JOURNAL_TOGGLE_DESIGN_SUMMARY = "JOURNAL_TOGGLE_DESIGN_SUMMARY";
export const JOURNAL_SELECT_REVISION = "JOURNAL_SELECT_REVISION";
